import { render, staticRenderFns } from "./ModalCreateNewPaymentType.vue?vue&type=template&id=38657b09&"
import script from "./ModalCreateNewPaymentType.vue?vue&type=script&lang=js&"
export * from "./ModalCreateNewPaymentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports